const url = 'cash_box_op';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';
import { actions as sale_actions } from "../../redux/modules/sales";
import moment from "moment";
moment.locale('es');

const LOADER_ARQUEO = 'LOADER_ARQUEO';
const SET_DATA_ARQUEO = 'SET_DATA_ARQUEO';
const SET_PAGE_ARQUEO = 'SET_PAGE_ARQUEO';
const SET_UPDATE_DATA_ARQUEO = 'SET_UPDATE_DATA_ARQUEO';
const SET_BUSCADOR_ARQUEO = 'SET_BUSCADOR_ARQUEO';
const SET_FILTRO_ARQUEO = 'SET_FILTRO_ARQUEO';

const SET_MONTH = 'SET_MONTH';
const SET_YEAR = 'SET_YEAR';
const SET_CATEGORY_DETAIL = 'SET_CATEGORY_DETAIL';

const groupBy = (xs, f) => {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
}

const listar = (page = 1) => (dispatch, getStore) => {
    dispatch({ type: LOADER_ARQUEO, cargando: true });
    const store = getStore();
    const search = store.arqueo.buscador;
    const filtro = store.arqueo.filtro_roles;

    const date_string = '15/' + store.banks.month.value + '/' + store.banks.year.value
    const date_moment = moment(date_string, "DD/MM/YYYY")
    const initial_date = date_moment.startOf('month').format('DD/MM/YYYY')
    const final_date = date_moment.endOf('month').format('DD/MM/YYYY')

    let params = { page, search, initial_date, final_date };
    if (filtro) {
        params[''] = filtro
    }

    api.get(`${url}/getArqueos`, params).catch((error) => {
        dispatch({ type: LOADER_ARQUEO, cargando: false });
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        console.log("Data: ", data);

        if (data) {
            dispatch({ type: SET_DATA_ARQUEO, data });
            dispatch({ type: SET_PAGE_ARQUEO, page });
        }
        dispatch({ type: LOADER_ARQUEO, cargando: false });
    })
};

const detail = id_ocbx => (dispatch, getState) => {
    dispatch({ type: LOADER_ARQUEO, cargando: true });
    api.get(`${url}/getCashBoxDetail`, { id_ocbx }).catch((error) => {
        dispatch({ type: LOADER_ARQUEO, cargando: false });
        if (error.statusCode === 404) {
            dispatch(push('/arqueos'))
        }
    }).then((data) => {
        dispatch({ type: LOADER_ARQUEO, cargando: false });
        if (data) {
            console.log("detail: ", data);
            dispatch({ type: SET_UPDATE_DATA_ARQUEO, updateData: data });

            api.get(`${url}/obtenerDetalleDeCategoria`, { id_ocbx }).catch((error) => {
                dispatch({ type: LOADER_ARQUEO, cargando: false });
                if (error.statusCode === 404) {
                    dispatch(push('/arqueos'))
                }
            }).then((data) => {
                dispatch({ type: LOADER_ARQUEO, cargando: false });
                if (data) {
                    //const result = groupBy(data, (x) => x.financial_entity);
                    //console.log("Category Detail: ", result);
                    //dispatch({type: SET_CATEGORY_DETAIL, category_detail: result});
                    dispatch({ type: SET_CATEGORY_DETAIL, category_detail: data });
                }
            })
        }
    })
}

const search = (search) => (dispatch) => {
    dispatch({ type: SET_BUSCADOR_ROL, buscador: search });
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0) {
        filtro = null
    }
    dispatch({ type: SET_FILTRO_ROL, filtro_rol: filtro });
    dispatch(listar(1));
};

const set_month = (value) => (dispatch, getStore) => {
    const store = getStore()
    dispatch({ type: SET_MONTH, month: value })
    dispatch(listar());
}

const set_year = (value) => (dispatch, getStore) => {
    const store = getStore()
    dispatch({ type: SET_YEAR, year: value })
    dispatch(listar());
}

const openAccount = (codigo) => (dispatch) => {
    dispatch(sale_actions.openAccount(codigo));
}

export const actions = {
    listar,
    detail,
    search,
    filtro,
    set_year,
    set_month,
    openAccount,
};

export const reducer = {
    [LOADER_ARQUEO]: (state, { cargando }) => {
        return { ...state, cargando }
    },
    [SET_DATA_ARQUEO]: (state, { data }) => {
        return { ...state, data }
    },
    [SET_PAGE_ARQUEO]: (state, { page }) => {
        return { ...state, page }
    },
    [SET_UPDATE_DATA_ARQUEO]: (state, { updateData }) => {
        return { ...state, updateData }
    },
    [SET_BUSCADOR_ARQUEO]: (state, { buscador }) => {
        return { ...state, buscador }
    },
    [SET_FILTRO_ARQUEO]: (state, { filtro_rol }) => {
        return { ...state, filtro_rol }
    },
    [SET_MONTH]: (state, { month }) => {
        return { ...state, month }
    },
    [SET_YEAR]: (state, { year }) => {
        return { ...state, year }
    },
    [SET_CATEGORY_DETAIL]: (state, { category_detail }) => {
        return { ...state, category_detail }
    }
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_roles: null,
    updateData: {},

    month: { value: moment().format("MM"), label: moment().format("MMMM").charAt(0).toUpperCase() + moment().format("MMMM").slice(1) },
    year: { value: moment().format('YYYY'), label: moment().format('YYYY') },
    category_detail: [],
};

export default handleActions(reducer, initialState)
